
import Seo from '../../components/Seo';
const FEATURES = [
  {
    href: '/features/ask-teamgrid',
    color: '#8B75D7',
    tint: 'rgba(139,117,215,.12)',
    title: 'Ask TeamGrid',
    desc: 'Ask a question in plain English, get the answer from your own work data.',
    paths: ['M4 5h16v11H9l-5 4V5z', 'M8.5 10.5h7'],
  },
  {
    href: '/features/automatic-time-tracking',
    color: '#007A6E',
    tint: 'rgba(0,122,110,.12)',
    title: 'Automatic Time Tracking',
    desc: 'Silent, precise tracking across every app and project. Zero manual input.',
    paths: ['M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z', 'M12 7v5.4l3.4 2'],
  },
  {
    href: '/features/productivity-scoring',
    color: '#2DBDB8',
    tint: 'rgba(45,189,184,.14)',
    title: 'Productivity Scoring',
    desc: 'Live productivity metrics for individuals and teams, from real activity.',
    paths: ['M3 17l6-6 4 4 7-7', 'M15 8h6v6'],
  },
  {
    href: '/features/ai-work-summaries',
    color: '#6C59A6',
    tint: 'rgba(108,89,166,.12)',
    title: 'AI Work Summaries',
    desc: 'Daily and monthly reports written for you, so standups become optional.',
    paths: ['M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z', 'M9 13h6M9 17h4'],
  },
  {
    href: '/features/app-website-tracking',
    color: '#469FD8',
    tint: 'rgba(70,159,216,.12)',
    title: 'App & Website Tracking',
    desc: 'See which applications and sites the work actually happens in.',
    paths: ['M3 5h18v11H3z', 'M9 20h6M12 16v4'],
  },
  {
    href: '/features/hourly-breakdown',
    color: '#F2673A',
    tint: 'rgba(242,103,58,.12)',
    title: 'Hourly Breakdown',
    desc: 'Hour-by-hour focus, meetings and idle. One glance tells you the day.',
    paths: ['M4 20V11M9 20V4M14 20v-6M19 20v-9'],
  },
  {
    href: '/features/team-management',
    color: '#34A851',
    tint: 'rgba(52,168,81,.12)',
    title: 'Team Management',
    desc: 'Roles, permissions and org hierarchy that stay current on their own.',
    paths: ['M9 11a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2z', 'M2.5 20.5c0-3.6 2.9-6.5 6.5-6.5s6.5 2.9 6.5 6.5', 'M16.5 4.6a3.6 3.6 0 0 1 0 6.9M17.5 14.4c2.3.8 4 3 4 5.6'],
  },
  {
    href: '/features/project-tracking',
    color: '#F2A73A',
    tint: 'rgba(242,167,58,.14)',
    title: 'Project Tracking',
    desc: 'Project progress and team allocation, reported by the work itself.',
    paths: ['M3 4.5h18v15H3z', 'M9 4.5v15M15 4.5v15'],
  },
  {
    href: '/features/org-intelligence',
    color: '#366EB6',
    tint: 'rgba(54,110,182,.12)',
    title: 'Org Intelligence',
    desc: 'Organization-wide performance patterns, surfaced before they cost you.',
    paths: ['M4 21V7l8-4 8 4v14', 'M9.5 21v-5h5v5', 'M8.5 10.5h.01M12 10.5h.01M15.5 10.5h.01'],
  },
];

export default function FeaturesPage() {
  
  return (
    <>
      <Seo title="Features — AI Workforce Intelligence & Productivity | TeamGrid™" description="Nine ways to see how work happens: automatic time tracking, productivity scores, AI summaries and more. Privacy first, with no screenshots or keystrokes." />
      <header className="fh">
        <div className="fh-grid">
          <div className="fh-copy">
            <span className="hero-badge"><img className="mark" src="/assets/mark-teamgrid.svg" alt="" />Product <span className="arr">›</span></span>
            <h1 style={{fontSize: '52px', lineHeight: '57px', letterSpacing: '-2.1px', fontWeight: '700', color: 'var(--ink-hero)', marginBottom: '22px'}}>Nine ways to see<br /><span style={{color: '#a9aab3'}}>how work happens</span></h1>
            <p style={{fontSize: '17px', lineHeight: '26px', color: 'var(--ink-soft)', maxWidth: '620px', marginBottom: '30px'}}>One platform, built privacy-first. No screenshots, no keystrokes, patterns not people. Pick the piece you need today, the rest is already running.</p>
            <div className="hero-cta-row" style={{marginBottom: '0'}}>
              <a className="btn-primary" href="/register">Get started FREE</a>
              <span className="hero-cta-note">7-day free trial.<br />No credit card.</span>
            </div>
          </div>
          <div className="fh-vis">
            <div className="frame">
              <div className="frame-h">
                <span className="dots"><span style={{background: '#ff5f57'}}></span><span style={{background: '#febc2e'}}></span><span style={{background: '#28c840'}}></span></span>
                ONE AGENT — NINE FEATURES, TODAY
              </div>
              <div className="applist" style={{padding: '16px 18px 12px'}}>
                <span className="ap"><i style={{background: '#007A6E'}}></i>Time Tracking<span className="bar"><b style={{width: '92%', background: '#007A6E'}}></b></span><span className="pc">6.4h</span></span>
                <span className="ap"><i style={{background: '#2DBDB8'}}></i>Productivity Score<span className="bar"><b style={{width: '84%', background: '#2DBDB8'}}></b></span><span className="pc">84</span></span>
                <span className="ap"><i style={{background: '#469FD8'}}></i>Apps &amp; Sites<span className="bar"><b style={{width: '68%', background: '#469FD8'}}></b></span><span className="pc">21</span></span>
                <span className="ap"><i style={{background: '#F2673A'}}></i>Hourly Breakdown<span className="bar"><b style={{width: '55%', background: '#F2673A'}}></b></span><span className="pc">9h</span></span>
                <span className="ap"><i style={{background: '#8B75D7'}}></i>Ask TeamGrid<span className="bar"><b style={{width: '41%', background: '#8B75D7'}}></b></span><span className="pc">12</span></span>
                <span className="ap"><i style={{background: '#6C59A6'}}></i>AI Summaries<span className="bar"><b style={{width: '33%', background: '#6C59A6'}}></b></span><span className="pc">3</span></span>
              </div>
              <div className="sumcard" style={{borderTop: '1px solid var(--line-soft)'}}>
                <div className="sc-t">ONE TIMELINE — NOTHING TO STITCH</div>
                <p>All nine features read the <b>same activity stream</b>. Every number above came from <b>0 timers started</b> and <b>0 screenshots</b>.</p>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="sect" style={{paddingTop: '8px'}}>
        <div className="container">
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '18px', maxWidth: '1160px', margin: '0 auto'}}>
            {FEATURES.map((f) => (
              <a key={f.href} className="roi-card" href={f.href} style={{display: 'block', padding: '26px 24px', textDecoration: 'none'}}>
                <span style={{display: 'flex', width: '44px', height: '44px', borderRadius: '13px', alignItems: 'center', justifyContent: 'center', background: f.tint, marginBottom: '18px'}}>
                  <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24">
                    {f.paths.map((d, i) => (
                      <path key={i} d={d} fill="none" stroke={f.color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                    ))}
                  </svg>
                </span>
                <span style={{display: 'block', fontSize: '18px', lineHeight: '24px', fontWeight: '700', letterSpacing: '-0.3px', color: 'var(--ink-strong)', marginBottom: '8px'}}>{f.title}</span>
                <span style={{display: 'block', fontSize: '13.5px', lineHeight: '20px', color: 'var(--ink-soft)', marginBottom: '14px'}}>{f.desc}</span>
                <span style={{display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '12.5px', fontWeight: '700', color: f.color}}>See how it works →</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section className="sect" style={{paddingTop: '0'}}>
        <div className="container">
          <div className="roi-cards" style={{marginTop: '0'}}>
            <div className="roi-card"><div className="rl">FEATURES</div><div className="rv">9</div><p>One platform, one timeline. Nothing to stitch together.</p></div>
            <div className="roi-card"><div className="rl">SETUP</div><div className="rv">5 min</div><p>One lightweight agent. No IT project, no training sessions.</p></div>
            <div className="roi-card"><div className="rl">MANUAL ENTRY</div><div className="rv">0</div><p>No timers, no forms. Hours build themselves from real work.</p></div>
            <div className="roi-card"><div className="rl">SCREENSHOTS</div><div className="rv">0</div><p>Ever. Patterns, not people — measurement with dignity.</p></div>
          </div>
        </div>
      </section>

      <div className="container"><div className="workswith"><span className="wl">GOES DEEPER WITH</span><a href="/monitoring">Workforce Analytics →</a><a href="/pattern-intelligence">Pattern Intelligence →</a></div></div>

      <section className="sect" style={{padding: '8px 0 24px'}}>
        <div className="container">
          <h2 className="sect-h2" style={{fontSize: '28px', lineHeight: '36px'}}>Common questions</h2>
          <div className="faq">
            <details>
              <summary>Do I have to turn features on one by one?</summary>
              <p>No. Every feature listed here runs from the same agent and the same activity data. Turn on what your team needs to see, and the rest keeps collecting quietly in the background.</p>
            </details>
            <details>
              <summary>What does TeamGrid actually record?</summary>
              <p>Application and website usage, focus periods, meetings, idle time and project context. Never screenshots, never keystrokes. Everyone can see their own data.</p>
            </details>
            <details>
              <summary>Where should a new team start?</summary>
              <p>Automatic Time Tracking first, because it needs nothing from your people. Add AI Work Summaries in week two, once there is enough history for the reports to be worth reading.</p>
            </details>
          </div>
        </div>
      </section>

      <section className="final" style={{paddingTop: '48px'}}>
        <div className="container-wide">
          <div className="final-band" style={{paddingBottom: '88px'}}>
            <h2>Nine features.<br />One honest picture.</h2>
            <a className="btn-white" href="/register">Get started FREE</a>
          </div>
        </div>
      </section>
    </>
  );
}
